module.exports = __webpack_public_path__ + "img/img-cc2e4a.png";